import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

type Props = {
	rootNode: Element;
	children: React.ReactNode;
};

const ReplacementPortal = ({ children, rootNode }: Props) => {
	const [isActive, setIsActive] = useState(false);

	useEffect(() => {
		setIsActive(true);
		rootNode.innerHTML = '';
	}, [rootNode]);

	if (!isActive) {
		return null;
	}

	return ReactDOM.createPortal(children, rootNode);
};

export default ReplacementPortal;
